/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module representing a bidding error.
 * @module utilities/errors/bidding
 */
"use strict";

var util = require("util");
var WError = require("verror").WError;

/**
 * Represents a bidding error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 */
function BiddingError(cause, message) {
  this.name = "BiddingError";
  this.message = message || "Error while placing bid.";

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(BiddingError, WError);

/**
 * Represents an invalid bidding amount error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 * @param {String} propertyName - Reason of the invalidity of the bid amount.
 */
function InvalidBidAmountError(cause, message, propertyName) {
  this.name = "InvalidBidAmountError";
  this.message = message || "Invalid bid amount.";
  this.propertyName = propertyName;

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(InvalidBidAmountError, BiddingError);

/**
 * Represents a too low bidding amount error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 * @param {String} propertyName - Amount of the bid too low.
 */
function BidTooLowError(cause, message, propertyName) {
  this.name = "BidTooLowError";
  this.message = message || "Bid amount too low.";
  this.propertyName = propertyName;

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(BidTooLowError, BiddingError);

/**
 * Represents an already leading bidding error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 * @param {String} propertyName - Amount with which already leading.
 */
function AlreadyLeadingBidError(cause, message, propertyName) {
  this.name = "AlreadyLeadingBidError";
  this.message = message || "Already owning the leading bid.";
  this.propertyName = propertyName;

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(AlreadyLeadingBidError, BiddingError);

/**
 * Represents an invalid bidding lot error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 * @param {String} propertyName - Reason of the invalidity of the bid lot.
 */
function InvalidBidLotError(cause, message, propertyName) {
  this.name = "InvalidBidLotError";
  this.message = message || "Invalid lot to bid on.";
  this.propertyName = propertyName;

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(InvalidBidLotError, BiddingError);

module.exports = exports = BiddingError;

BiddingError.InvalidBidAmountError = InvalidBidAmountError;
BiddingError.BidTooLowError = BidTooLowError;
BiddingError.AlreadyLeadingBidError = AlreadyLeadingBidError;
BiddingError.InvalidBidLotError = InvalidBidLotError;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/errors/bidding.js
// module id = 866
// module chunks = 6